import { css } from '@emotion/css';

export const firstLevelContainerCx = (isFirstLevel: boolean) => css`
  padding-top: ${isFirstLevel ? '56px' : '0'};
`;
